var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.999,
    height: 24,
    viewBox: "0 0 23.999 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Light-Mode-Icon",
    d: "M12,7.5A4.5,4.5,0,1,0,16.5,12,4.507,4.507,0,0,0,12,7.5Zm11.55,3.773L19.111,9.056l1.57-4.706a.81.81,0,0,0-1.027-1.027l-4.706,1.57L12.727.45a.812.812,0,0,0-1.453,0L9.056,4.889,4.345,3.319A.81.81,0,0,0,3.319,4.345l1.57,4.706L.45,11.273a.812.812,0,0,0,0,1.453l4.439,2.217-1.57,4.711a.81.81,0,0,0,1.027,1.027l4.706-1.57,2.217,4.439a.812.812,0,0,0,1.453,0l2.217-4.439,4.706,1.57a.81.81,0,0,0,1.027-1.027L19.1,14.948l4.439-2.217a.813.813,0,0,0,.009-1.458Zm-7.308,4.969a6,6,0,1,1,0-8.484A6.006,6.006,0,0,1,16.242,16.242Z",
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMode);
export default __webpack_public_path__ + "static/media/LightMode.24c4b555b4971170f07c1a2d89b6647e.svg";
export { ForwardRef as ReactComponent };